import { jsxs as l, jsx as c } from "react/jsx-runtime";
import { nanoid as e } from "nanoid";
import m, { useState as h, useMemo as f, useEffect as v, useContext as p } from "react";
import { S as u } from "../../errors-YTprc4A2.mjs";
import { g as t } from "../../helpers-CNa1KUVl.mjs";
import { F as g } from "../../styled-qu50FBLM.mjs";
const n = m.createContext({}), C = [
  {
    id: e(),
    text: "Find services",
    href: "#",
    itemLevel: 0,
    state: "Collapsed",
    subItems: [
      {
        id: e(),
        text: "Transport and driving",
        href: `${t()}/find-services/transport-and-driving`,
        itemLevel: 1,
        state: "Collapsed",
        subItems: [
          {
            id: e(),
            text: "Registration",
            href: `${t()}/find-services/transport-and-driving/registration`,
            itemLevel: 2,
            state: "Collapsed",
            subItems: [
              {
                id: e(),
                text: "Check registration",
                href: `${t()}/find-services/transport-and-driving/registration/check-registration`,
                itemLevel: 3,
                state: "Collapsed"
              },
              {
                id: e(),
                text: "Renew registration",
                href: `${t()}/find-services/transport-and-driving/registration/renew-registration`,
                itemLevel: 3,
                state: "Collapsed"
              }
            ]
          }
        ]
      },
      {
        id: e(),
        text: "Personal",
        href: `${t()}/find-services/personal`,
        itemLevel: 1,
        state: "Collapsed",
        subItems: [
          {
            id: e(),
            text: "Apply for a proof of age card",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/find-services/personal/apply-for-a-proof-of-age-card`
          },
          {
            id: e(),
            text: "Make a will",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/personal/make-a-will`
          },
          {
            id: e(),
            text: "Ambulance membership",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/personal/ambulance-membership`,
            subItems: [
              {
                id: e(),
                text: "Become an Ambulance Victoria member",
                itemLevel: 3,
                state: "Collapsed",
                href: `${t()}/find-services/personal/ambulance-membership/become-a-member`
              },
              {
                id: e(),
                text: "Renew Ambulance Victoria membership",
                itemLevel: 3,
                state: "Collapsed",
                href: `${t()}/find-services/personal/ambulance-membership/renew-membership`
              },
              {
                id: e(),
                text: "Update Ambulance Victoria details",
                itemLevel: 3,
                state: "Collapsed",
                href: `${t()}/find-services/personal/ambulance-membership/update-membership`
              }
            ]
          }
        ]
      },
      {
        id: e(),
        text: "Work and volunteering",
        href: `${t()}/find-services/work-and-volunteering`,
        itemLevel: 1,
        state: "Collapsed",
        subItems: [
          {
            id: e(),
            text: "Working with Children Check",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/work-and-volunteering/working-with-children-check`,
            subItems: [
              {
                id: e(),
                text: "Change from volunteer to employee",
                itemLevel: 3,
                state: "Collapsed",
                href: `${t()}/find-services/work-and-volunteering/working-with-children-check/change-from-volunteer-to-employee`
              },
              {
                id: e(),
                text: "Renew your Working with Children Check",
                itemLevel: 3,
                state: "Collapsed",
                href: `${t()}/find-services/work-and-volunteering/working-with-children-check/renew-your-working-with-children-check`
              },
              {
                id: e(),
                text: "Update your Working with Children Check details",
                itemLevel: 3,
                state: "Collapsed",
                href: `${t()}/find-services/work-and-volunteering/working-with-children-check/update-your-working-with-children-check-details`
              }
            ]
          }
        ]
      },
      {
        id: e(),
        text: "Outdoor and recreation",
        href: `${t()}/find-services/outdoor-and-recreation`,
        itemLevel: 1,
        state: "Collapsed",
        subItems: [
          {
            id: e(),
            text: "Register a party with the Partysafe program",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/outdoor-and-recreation/register-a-party-with-the-partysafe-program`
          },
          {
            id: e(),
            text: "Buy a fishing licence",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/outdoor-and-recreation/buy-a-victorian-recreational-fishing-licence`
          },
          {
            id: e(),
            text: "Find a kangaroo harvester",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/outdoor-and-recreation/find-a-kangaroo-harvester`
          }
        ]
      },
      {
        id: e(),
        text: "Housing and property",
        href: `${t()}/find-services/housing-and-property/`,
        itemLevel: 1,
        state: "Collapsed",
        subItems: [
          {
            id: e(),
            text: "Register absence from residence",
            itemLevel: 2,
            state: "Collapsed",
            href: `${t()}/find-services/housing-and-property/register-your-absence-from-residence`
          }
        ]
      },
      {
        id: e(),
        text: "Crime and the law",
        itemLevel: 1,
        state: "Collapsed",
        href: `${t()}/find-services/crime-and-the-law`
      }
    ]
  },
  {
    id: e(),
    text: "About us",
    href: "#",
    itemLevel: 0,
    state: "Collapsed",
    subItems: [
      {
        id: e(),
        text: "Our story",
        itemLevel: 1,
        state: "Collapsed",
        href: `${t()}/about-us/our-story`
      }
    ]
  },
  {
    id: e(),
    text: "Contact us",
    href: "#",
    itemLevel: 0,
    state: "Collapsed",
    subItems: [
      {
        id: e(),
        text: "Chat with us",
        itemLevel: 1,
        state: "Collapsed",
        href: `${t()}/contact/chat-with-us`
      },
      {
        id: e(),
        text: "Send us a message",
        itemLevel: 1,
        state: "Collapsed",
        href: `${t()}/contact/send-us-a-message`
      }
    ]
  }
], y = (i) => {
  const [r, s] = h(() => i.isOpen ?? !1), o = f(
    () => ({
      isOpen: r,
      setIsOpen: s,
      items: i.items ?? C
    }),
    [r, i.items]
  ), a = (d) => {
    d.persisted && s(!1);
  };
  return v(() => (window.addEventListener("pagehide", a), () => {
    window.removeEventListener("pagehide", a);
  }), []), /* @__PURE__ */ l(n.Provider, { value: o, children: [
    /* @__PURE__ */ c(g, { isEnabled: r }),
    i.children
  ] });
};
function I() {
  const i = p(n);
  if (!i)
    throw new u("SideNavContext must be used with SidenavProvider!");
  return i;
}
export {
  y as SideNavProvider,
  I as useSidenavContext
};
